import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';

import { Environment, ModelStr, ModelStrStr, SysImpostazioni } from '../../models/-index';

@Injectable()
export class SysImpostazioniService extends CrudGenericsService<SysImpostazioni, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/SysImpostazioni`);
    this.base = `${env.apiUrl}/api/SysImpostazioni/`;
  }
  // da cancellare dopo verifica ionic
  GetImpostazioni_byType(t: any): Observable<any> {
    const url = this.base + 'GetImpostazioni/' + t;
    return this.http.get<any>(`${url}`);
  }
  // da cancellare dopo verifica ionic
  GetImpostazioni(): Observable<SysImpostazioni> {
    const url = this.base + 'GetImpostazioni';
    return this.http.get<SysImpostazioni>(`${url}`);
  }
  // get  by chiave
  GetValue_ByChiave(chiave: string): Observable<ModelStr> {
    const key: ModelStr = { Value: chiave };
    const u = `${this.base}GetValue_ByChiave`;
    return this.http.post<ModelStr>(u, key);
  }
  // post uodate by chiave
  UpdateSetting_ByChiaveText(item: ModelStrStr) {
    const u = `${this.base}UpdateSetting_ByChiaveText}`;
    return this.http.post(u, item);
  }
}
